import { useAppSelector } from "../../../redux/store";
import { getServiceConfigNames } from './cloudAppAPI'

export const useServiceRedux = () => {
  const serviceConfigNames = useAppSelector((state) => getServiceConfigNames(state))

  return {
    serviceConfigNames: serviceConfigNames,
  }
}